import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../app/services/loader/loader.service';
import { environment } from 'src/environment/environment';
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private excludedUrls = [`${environment.url}/customers/auth/login/checkCustomerStatus`];
 
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const shouldShowLoader = !this.excludedUrls.some(url => req.url.includes(url));

    if (shouldShowLoader) {
      this.loaderService.show(); // ✅ Show loader for other API requests
    }
    // this.loaderService.show();
    return next.handle(req).pipe(
      finalize(() => {
        // this.loaderService.hide();
        if (shouldShowLoader) {
          this.loaderService.hide(); // ✅ Hide loader only if it was shown
        }
      })
    );
  }
}
